module.exports = __webpack_public_path__ + "img/images/our-vision.jpg?887592eb";